import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppContext } from "../context/AppContext";

import ArrowIcon from "./Icons/ArrowIcon";
import LogOutIcon from "./Icons/LogOutIcon";
import DashboardIcon from "./Icons/DashboardIcon";
import MessageIcon from "./Icons/MessageIcon";
import BellRingIcon from "./Icons/BellRingIcon";

import LogOutBtn from "./LogOutBtn";
import { PlusCircleIcon } from "./Icons";
import CookieService from "../context/cookies";

export default function UserDropdown() {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const userDropdownRef = useRef<HTMLDivElement | null>(null);
  const buttonRef = useRef<HTMLButtonElement | null>(null);

  const navigate = useNavigate();
  const location = useLocation();
  const roleCookie = CookieService.getCookie("role");

  const isDealTrackerPage = location.pathname === "/deal-tracker";

  const { user, userLoading } = useAppContext();

  const toggleDropdown = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    setIsDropdownOpen((prev) => !prev);
  };

  // Close the dropdown if the click is outside
  const handleClickOutside = (event: MouseEvent) => {
    if (
      userDropdownRef.current &&
      !userDropdownRef.current.contains(event.target as Node) &&
      buttonRef.current &&
      !buttonRef.current.contains(event.target as Node)
    ) {
      setIsDropdownOpen(false);
    }
  };

  // Add event listener when the component mounts and remove it when it unmounts
  useEffect(() => {
    document.addEventListener("click", handleClickOutside);

    // Cleanup listener when component unmounts
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  return (
    <div className="relative max-w-[340px] flex items-center justify-between gap-4">
      {roleCookie === "user" && (
        <>
          {!isDealTrackerPage && (
            <button
              id="dashbaord-create-order"
              className="none bg-custom-blue-medium text-sm py-2 px-3 hidden xl:flex items-center gap-1 text-white font-medium rounded-2xl"
              onClick={() => navigate("/deal-tracker")}
            >
              <PlusCircleIcon className="size-6" />
              Create Order
            </button>
          )}

          <div className="h-[40px] border-l-2 border-gray-300" />
        </>
      )}

      {/* notification section */}
      <div className="flex items-center gap-2 text-[#737373]">
        {/* <button>
          <TaskIcon className="size-6" />
        </button> */}

        <button
          className="p-1 hover:bg-slate-200 hover:text-custom-blue-medium hover:scale-95 rounded-lg"
          onClick={() => navigate("/messages")}
        >
          <MessageIcon className="size-6" />
        </button>
        <button className="p-1 hover:bg-slate-200 hover:text-custom-blue-medium hover:scale-95 rounded-lg">
          <BellRingIcon className="size-6" />
        </button>
      </div>

      {/* Profile section */}
      <button
        className="flex items-center gap-[2px] cursor-pointer"
        onClick={toggleDropdown}
        ref={buttonRef}
      >
        <div className="relative size-10 rounded-full flex items-center justify-center bg-custom-dark-blue-new border-2 border-white">
          {/* <img
            src={UserAvatar}
            alt="avatar"
            className="border-2 border-[#7373734A] rounded-full"
          /> */}
          <div className="font-bold text-lg text-white">
            {roleCookie === "user"
              ? user?.first_name?.at(0)?.toUpperCase()
              : roleCookie === "investor"
                ? "I"
                : ""}
          </div>

          <div className="absolute bottom-[2px] right-[2px] w-[10px] h-[10px] bg-green-500 rounded-full border-2 border-white" />
        </div>

        <ArrowIcon
          className={`size-6 text-[#1A1D21] transition-transform duration-300 ease-in-out ${
            isDropdownOpen ? "rotate-180" : ""
          }`}
        />
      </button>

      {/* Dropdown section */}
      {isDropdownOpen && (
        <div
          className="absolute right-0 top-10 bg-white text-[#1A1D21] w-[200px] p-1 rounded-lg shadow-2xl z-50"
          ref={userDropdownRef}
        >
          <div className="px-1 py-2 mb-1 border-b border-b-gray-100">
            {userLoading ? (
              <div className="animate-pulse space-y-2">
                <div className="h-3 w-[100px] bg-slate-300 rounded"></div>

                <div className="h-2 w-[60px] bg-slate-300 rounded"></div>
              </div>
            ) : (
              <div className="flex flex-col items-start">
                <p className="text-[#182230] font-medium">
                  {user ? `${user?.first_name} ${user?.last_name}` : "Investor"}
                </p>
                {roleCookie === "user" && (
                  <small className="text-[#737373] font-medium">
                    {user?.job_title || (
                      <span className="text-[10px] text-orange-400 bg-orange-50/60 px-1 rounded-lg border border-orange-200">
                        Action Required
                      </span>
                    )}
                  </small>
                )}
              </div>
            )}
          </div>

          {location.pathname === "/" && (
            <button
              className="w-full py-1 px-2 rounded-lg hover:bg-custom-off-white flex items-center gap-1"
              onClick={() => {
                if (roleCookie === "investor") {
                  navigate("/investor/dashboard");
                } else if (roleCookie === "user") {
                  navigate("/dashboard");
                }
                // navigate("/dashboard");
                setIsDropdownOpen(false);
              }}
            >
              <DashboardIcon className="size-5" /> <span>Go to dashboard</span>
            </button>
          )}

          <LogOutBtn className="w-full py-1 px-2 rounded-lg hover:bg-red-50 flex items-center gap-1">
            <LogOutIcon className="size-5" /> <span>Log Out</span>
          </LogOutBtn>
        </div>
      )}
    </div>
  );
}
